import { render, staticRenderFns } from "./HeadcountTurnover.vue?vue&type=template&id=5665eb66&"
import script from "./HeadcountTurnover.vue?vue&type=script&lang=js&"
export * from "./HeadcountTurnover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports